import { render, staticRenderFns } from "./CallQueueSoundFilesModal.vue?vue&type=template&id=4718a747&"
import script from "./CallQueueSoundFilesModal.vue?vue&type=script&lang=js&"
export * from "./CallQueueSoundFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./CallQueueSoundFilesModal.vue?vue&type=style&index=0&id=4718a747&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports